import { ExitToApp as OutsourcingIcon } from '@material-ui/icons';

import Outsourcing from './Outsourcing';

export default {
	list: Outsourcing,
	icon: OutsourcingIcon
};
